import React__default, { useState, useEffect } from 'react';
import { ConciergeProductCard } from './ConciergeProductCard.js';
import StoreCarousel from './StoreCarousel.js';
import { ProductCardCarouselWidget } from '@brandclub/bc-widgets';
import { useProductClickTracking } from './hooks/useProductClickTracking.js';

const ProductGroupCarousel = ({ products, allStacklineSkus = [], isLoading = false, }) => {
    const { trackProductClick } = useProductClickTracking();
    // Determine mobile view based on viewport width
    const [isMobileView, setIsMobileView] = useState(() => {
        if (typeof window === 'undefined')
            return false;
        return window.innerWidth < 500;
    });
    useEffect(() => {
        const handleResize = () => {
            setIsMobileView(window.innerWidth < 500);
        };
        window.addEventListener('resize', handleResize);
        return () => window.removeEventListener('resize', handleResize);
    }, []);
    // Show loading skeletons if loading and no products
    if (isLoading && products.length === 0) {
        return (React__default.createElement("div", { className: "tw:w-full" },
            React__default.createElement(StoreCarousel, null, [1, 2, 3, 4].map((i) => (React__default.createElement("div", { key: i, className: "tw:w-[240px] tw:h-[391.86px] tw:rounded-xl tw:bg-gray-200 tw:animate-pulse" }))))));
    }
    // Don't render if no products and no allStacklineSkus (nothing to show)
    if ((!products || products.length === 0) && allStacklineSkus.length === 0) {
        return null;
    }
    // Create a map of products by stacklineSku for easy lookup
    const productMap = new Map();
    products.forEach((product) => {
        productMap.set(product.stacklineSku, product);
    });
    // Use allStacklineSkus if provided, otherwise fall back to products
    const skusToRender = allStacklineSkus.length > 0 ? allStacklineSkus : products.map((p) => p.stacklineSku);
    return (React__default.createElement(ProductCardCarouselWidget, { widgetId: "product-card-carousel", displayName: "Product Card Carousel" }, (cardStyles, carouselStyles, themeFonts) => {
        // Get responsive item width
        const itemWidth = isMobileView ? carouselStyles.itemWidthMobile : carouselStyles.itemWidth;
        return (React__default.createElement("div", { className: "tw:w-full product-group-carousel" },
            React__default.createElement(StoreCarousel, { gap: carouselStyles.carouselGap }, skusToRender.map((sku, index) => {
                const product = productMap.get(sku);
                // If product metadata is available, render the product card
                if (product) {
                    return (React__default.createElement("div", { key: sku, style: { width: itemWidth, minWidth: itemWidth } },
                        React__default.createElement(ConciergeProductCard, { product: product, cardStyles: cardStyles, themeFonts: themeFonts, onProductClick: () => {
                                trackProductClick({
                                    stacklineSku: product.stacklineSku,
                                    productTitle: product.title,
                                    clickSource: 'carousel',
                                    productPosition: index,
                                    retailerId: product.retailerId,
                                    retailPrice: product.retailPrice,
                                    hasReward: product.hasRewards,
                                    rewardAmount: product.totalRewardAmount,
                                });
                            } })));
                }
                // If metadata not available yet, render nothing
                return null;
            }))));
    }));
};

export { ProductGroupCarousel };
//# sourceMappingURL=ProductGroupCarousel.js.map
